import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, SplitButton } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { KBSearchProps } from '../../../../../../types/KB/KBSearchProps';
import { KBApi } from '../../../../../../redux/api/KBApi';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

const KBButton: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const { profile: userProfile } = useCurrentUserContext();
    const [searchKB] = KBApi.useSearchKBMutation();
    const [kbResults, setKBResults] = React.useState<number>();
    const canAdd = userProfile?.Features.Add_Ticket_To_KnowledgeBase;
    const { data: ticketKbs } = KBApi.useGetTicketKbsQuery(ticket?.ID, { skip: !ticket?.ID });

    //Set the ticket details into the formstate
    React.useEffect(() => {
        if (ticket?.ID) {
            searchKB({ Description: ticket.Call_Desc, EndUserId: userProfile.Id, Ticket_Id: ticket?.ID, Count_Only: true } as KBSearchProps).unwrap().then((data) => {
                if (typeof data === 'number')
                    setKBResults(parseInt(data.toString()));
            })
        }
    }, [ticket?.ID]);

    const itemClicked = (event: any) => {
        navigate(`/deeplink/?url=${encodeURIComponent('/KBase/Default.aspx?Action=FromTicket&Call_ID=' + ticket.ID)}`);
    }

    const buttonLabel = `${ticketKbs?.length || 0} / ${kbResults?.toString() || 0}`;

    //Check if the feature is enabled
    if (!userProfile?.Features.KnowledgeBase || !userProfile?.Features.View_KB) return null;

    return (
        canAdd
            ? <SplitButton disabled={ticket.Is_Loading} onItemClick={itemClicked} items={[{ text: 'Add to Knowledge Base' }]} onButtonClick={() => navigate('Kbase')} title={'Knowledge base: linked / results '} imageUrl='./images/Toolbar/kb.png' text={buttonLabel} />
            : <Button disabled={ticket.Is_Loading} onClick={() => navigate('Kbase')} title={'Knowledge base: linked / results '} imageUrl='./images/Toolbar/kb.png'>{buttonLabel}</Button>

    );
};

export default KBButton;